export const ASHBY_CAREERS_URL = "https://jobs.ashbyhq.com/wayflyer";

/** Ashby "Register your interest!" speculative application form. */
export const SPECULATIVE_APPLICATION_URL =
  "https://jobs.ashbyhq.com/wayflyer/form/speculative-application";
